// extracted by mini-css-extract-plugin
export var resultEntry = "SearchWidget-module--resultEntry--07ab0";
export var resultEntryLink = "SearchWidget-module--resultEntryLink--b03b0";
export var resultEntryList = "SearchWidget-module--resultEntryList--1dd0f";
export var resultEntrySynopsis = "SearchWidget-module--resultEntrySynopsis--bb2a2";
export var resultEntryTitle = "SearchWidget-module--resultEntryTitle--60ea5";
export var results = "SearchWidget-module--results--bc5bc";
export var resultsSeparator = "SearchWidget-module--resultsSeparator--d176d";
export var searchField = "SearchWidget-module--searchField--3b715";
export var spinnerActive = "SearchWidget-module--spinnerActive--7b642";
export var spinnerInactive = "SearchWidget-module--spinnerInactive--0bde1";
export var toggle = "SearchWidget-module--toggle--2370c";
export var widget = "SearchWidget-module--widget--14922";
export var widgetInput = "SearchWidget-module--widgetInput--bdfde";
export var wrapper = "SearchWidget-module--wrapper--bcc35";